import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  useTheme,
  useMediaQuery
} from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import SearchIcon from "@mui/icons-material/Search";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ open, onSidebarToggle }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleDrawer = () => onSidebarToggle();
  const handleRedirect = (page) => {
    toggleDrawer();
    navigate(page);
  };

  const SIDEBAR_ITEMS = [
    {
      page: "/record",
      icon: <CreateIcon />,
      name: "Record Games"
    },
    {
      page: "/review",
      icon: <SearchIcon />,
      name: "Review Games"
    },
    {
      page: "/stats",
      icon: <EqualizerIcon />,
      name: "View Stats"
    },
    {
      page: "/",
      icon: <TipsAndUpdatesIcon />,
      name: "View Updates"
    },
    {
      page: "/settings",
      icon: <ManageAccountsIcon />,
      name: "Account Settings"
    }
  ];

  return (
    <Drawer anchor="right" open={open} onClose={toggleDrawer}>
      <List sx={{ width: isSmallScreen ? "100vw" : 250 }}>
        <ListItem>
          <ListItemIcon>
            <IconButton onClick={toggleDrawer}>
              <ChevronRightIcon />
            </IconButton>
          </ListItemIcon>
          <ListItemText> </ListItemText>
        </ListItem>
        <Divider />
        {SIDEBAR_ITEMS.map((item) => (
          <ListItem
            key={item.name}
            button
            onClick={() => handleRedirect(item.page)}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText>{item.name}</ListItemText>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

Sidebar.propTypes = {
  open: PropTypes.bool,
  onSidebarToggle: PropTypes.func
};

export default Sidebar;
